<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>


<div class="mt-3">
    <div class="row m-0 formborder d-flex align-items-center justify-content-between">

        <div class="col-md-2 p-1">
            <button class="btn back-btn" (click)="goBackToDashboard()">
                <i class="fa fa-arrow-left mr-1"></i> Back
            </button>
        </div>
        <div class="col-md-3 p-1 mt-2 align-left">
            <form action="" class="search-text">
                <div class="bg-light rounded rounded-pill shadow-sm">
                    <div class="input-group">
                        <input type="text" id="FilterInputSearch" (keyup)="applyFilter($event.target.value)"
                            name="FilterInputSearch" placeholder="What're you searching for?"
                            class="form-control border-0 bg-light" />
                        <div class="input-group-append">
                            <button id="button-addon1" type="submit" class="btn btn-link text-primary">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="table-responsive mt-3">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort
            [ngStyle]="displayedColumns.length <= 6 ? {'width':'100%','table-layout':'fixed'} : {'min-width': (displayedColumns.length * 160) + 'px'}"
            style="height: auto; overflow: auto; max-width: 100%;">
            <ng-container *ngFor="let col of displayedColumns" [matColumnDef]="col">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [style.width]="col === 'Loan_Id' ? '60px' : 'auto'"
                    [style.minWidth]="col === 'Loan_Id' ? '60px' : '120px'">
                    {{ columnDisplayNames[col] || col }}
                </th>
                <td mat-cell *matCellDef="let row; let i = index" [style.width]="col === 'Loan_Id' ? '60px' : 'auto'"
                    [style.minWidth]="col === 'Loan_Id' ? '60px' : '120px'">
                    {{ col === 'Loan_Id' ? (i + 1) : row[col] }}
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <div class="col-md-12 row mt-2">
            <div class="col-md-4">
                <button class="mt-2 btn font-size-12 button-btn" (click)="exportexcelReport()">
                    <i class="fa fa-file-export mr-1"></i> Export
                </button>
            </div>
            <div class="col-md-8">
                <mat-paginator [pageSizeOptions]="[20, 50]" showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </div>
</div>